import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useLocation, Link } from 'react-router-dom';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import Challan from './downloadChellan';
import Loader from '../../components/loader';
import newEWayBill from './eWayBill';

function formatNumber(number, length) {
    return String(number).padStart(length, '0');
}

function App() {

    const bottomRef = useRef(null);
    
    const scrollToBottom = () => {
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const location = useLocation();
    const [loader, setLoader] = useState(false);
    const userID = sessionStorage.getItem("TRCUserId");
    const userEmail = sessionStorage.getItem("TRCUserEmail");
    const userName = sessionStorage.getItem("TRCUserName");
    const userPosition = sessionStorage.getItem("TRCUserPosition");
    const userType = sessionStorage.getItem("TRCUserType");

    const [orderData, setOrderData] = useState('');
    const [orderId, setOrderId] = useState(null);
    const [address, setAddress] = useState([]);
    const [dispatchAddress, setDispatchAddress] = useState(null);
    const [cartItems, setCartItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [gst, setGST] = useState(0);
    const [crates, setCrates] = useState(0);
    const [qty, setQty] = useState(0);
    const [weight, setWeight] = useState(0);
    const [edit, setEdit] = useState(false);
    const [inputData, setInputData] = useState('');
    const [newTotal, setNewTotal] = useState(0);
    const [newGst, setNewGst] = useState(0);
    const [newDiscount, setNewDiscount] = useState(0);
    const [scheme, setScheme] = useState(0);
    const [vNum, setVNum] = useState('');
    const [eNum, setENum] = useState('');
    const [discounts, setDiscounts] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [shipping, setShipping] = useState(null);
    const [shippingAddress, setShippingAddress] = useState(null);

    const [newDiscountData, setNewDiscountData] = useState([]);
    const [addSection, setAddSection] = useState(false);
    const [ewbPop, setEwbPop] = useState(false);
    const [ewbError, setEWBError] = useState(null);
    const [ewbInputs, setEWBInputs] = useState([]);
    const [distError, setDisterror] = useState(null);

    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(param);
    };

    console.log(orderData);

    useEffect(() => {
        const orderid = getQueryParam('id');
        setOrderId(orderid);
    }, [userID]);

    useEffect(() => {
        scrollToBottom();
    }, [edit]);

    const getOrder = async () => {
        try {
            const response = await axios.post('https://api.trucoo.in/chellan/order-details/', {orderId: orderId}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(response.data);
            if(response.data.status === 'success'){
                setOrderData(response.data.data);
                setDiscounts(JSON.parse(response?.data?.data?.discountData || '[]'));
                setDispatchAddress(response.data.data?.dispatch?.id);
                setShippingAddress(response.data.data?.ships);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    const getAddress = async () => {
        try {
            const response = await axios.get('https://api.trucoo.in/address/get/', {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(response.data);
            if(response.data.status === 'success'){
                setAddress(response.data.data);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    const getShipping = async (id) => {
            try {
                const response = await axios.post('https://api.trucoo.in/shipping/get/', {dealerId : id}, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-KEY': 'erpTrucoo'
                    }
                });
                //console.log(response.data);
                if(response.data.status === 'success'){
                    setShipping(response.data.data);
                }
            } catch (error) {
                console.error("Error:", error.response || error.message);
            }
        };

    useEffect(() => {
        getOrder();
        getAddress();
    },[orderId]);




    const getNewDiscounts = (product) => {
        
        const productData = orderData?.orderData?.find(items => items.itemId === product);
        const discountData = newDiscountData?.find(items => items.item === product); 
    
        const qty = parseFloat(productData.qty);
        const price = parseFloat(productData.itemPrice);
        const crates = parseFloat(productData.itemGrade);
        const weight = parseFloat(productData.itemWeight);
        const gst = parseFloat(productData.itemGst);
        const productGst = price - (price / (1 + gst / 100)) || 0;
        const productPrice = price - productGst || 0;

        if (!productData || !discountData) {
             //console.warn("Product or discount not found");
            return 0; 
        }

        if(discountData.discount !== 'amount'){
            return 0;
        }

        if(discountData.type === 'grade'){

            if(discountData.crate === 'packet'){
                return (parseFloat(productPrice) * parseFloat(discountData.value)) * parseFloat(qty)
            }else{
                return parseFloat(discountData.value) * parseFloat(qty)
            }
        }

        if(discountData.type === 'percent'){
            const total = parseFloat(qty) * parseFloat(crates)* parseFloat(productPrice);
            return total*(parseFloat(discountData.value)/100)
        }

        if(discountData.type === 'liters'){

            if(discountData.crate === 'litre'){
                const litters = (parseFloat(qty) * parseFloat(crates)) * (parseFloat(weight)/1000)
                const weights = litters * discountData.value;
                const ltr = (weights * 1000) / weight;
                return ltr * productPrice
            }else{
                const litters = (parseFloat(qty) * parseFloat(crates)) * (parseFloat(weight)/1000)
                return litters * discountData.value
            }
        }

        if(discountData.type === 'packet'){
            const values = parseFloat(discountData.value);
            const disQty = parseFloat(qty) * parseFloat(crates);
            return disQty * values;
        }

        return 0;
    };










    const getDiscountCrates = (product) => {
     
        
        const productData = orderData?.orderData?.find(items => items.itemId === product);
        const discountData = discounts?.find(items => items.item === product); 

        if (!productData || !discountData) {
            console.warn("Product or discount not found");
            return 0; 
        }
    
        const qty = parseFloat(productData.qty);
        const price = parseFloat(productData.itemPrice);
        const crates = parseFloat(productData.itemGrade);
        const weight = parseFloat(productData.itemWeight);
        const gst = parseFloat(productData.gst);
        const productGst = price - (price / (1 + gst / 100)) || 0;
        const productPrice = price - productGst || 0;
    
        if (isNaN(qty) || isNaN(productPrice) || isNaN(crates) || isNaN(weight)) {
            console.warn("Invalid product data");
            return 0;
        }
    
        if (!discountData.value || isNaN(discountData.value)) {
            console.warn("Invalid discount value");
            return 0;
        }

        if(discountData.discount === 'amount'){
            return 0;
        }
    
        if (discountData.type === 'grade') {
            if (discountData.crate === 'packet') {
                return (parseFloat(discountData.value) * qty) / crates;
            } else {
                return ((parseFloat(discountData.value) * qty) / productPrice) / crates;
            }
        }
    
        if (discountData.type === 'percent') {
            const total = qty * crates * productPrice;
            return total * (parseFloat(discountData.value) / 100);
        }
    
        if (discountData.type === 'liters') {
            if (discountData.crate === 'litre') {
                const ltrs = qty * crates * (weight/1000);
                const discLtr = ltrs * discountData.value;
                return (discLtr / crates);
            } else {
                const ltrs = qty * crates * (weight/1000);
                const ltrprice = ltrs * discountData.value;
                const ltrQty = ltrprice/productPrice;
                return (ltrQty / crates);
            }
        }
    
        return 0;
    };

    //console.log(orderData); 

    const getTotal = () => {
        // Initialize totals to zero
        let allTotal = 0;
        let allGst = 0;
        let allQty = 0;
        let allSubTotal = 0;
        let crate = 0;
        let weight = 0;
    
        orderData?.orderData?.forEach(data => {
            const price = parseFloat(data.itemPrice) || 0;
            const gst = parseFloat(data.itemGst) || 0;
            
            const disCrates = getDiscountCrates(data.itemId);
            //console.log(disCrates);
            
            const productGst = price - (price / (1 + gst / 100)) || 0;
            const productPrice = price - productGst || 0;
    
            allTotal += price * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade);
            allGst += productGst * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade);
            allSubTotal += productPrice * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade);
            allQty += (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)|| 0;
            crate += (parseFloat(data.qty) + parseFloat(disCrates));
            weight +=  (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade) * (parseFloat(data.itemWeight)/1000);
            
        });
    
        // Set the final values
        setTotal(allSubTotal);
        setGST(allGst);
        setGrandTotal(allTotal);
        setENum(orderData?.eWayNum);
        setVNum(orderData?.vNum);
        setCrates(crate);
        setQty(allQty);
        setWeight(weight);
        getShipping(orderData?.dealerData?.id);
    };

    
    const updateVENums = async () => {
        const sendDatas = {
            orderId: orderId,
            vNum : vNum,
            eNum: eNum,
            address: dispatchAddress,
            shipping: shippingAddress
        };
        try {
            const response = await axios.post('https://api.trucoo.in/chellan/evnum/', sendDatas, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(response.data);
            if(response.data.status === 'success'){
                alert('Updated!');
                getOrder();
                cancel();
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };
    

    const changeStatus = async () => {
        try {
            const response = await axios.post('https://api.trucoo.in/invoice/payment/', {orderId: orderId}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(response.data);
            if(response.data.status === 'success'){
                alert('Updated!');
                getOrder();
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };
    const setInuputs = () => {
        if (orderData && orderData?.orderData) {
            const updatedCartItems = orderData.orderData.map((items) => ({
                product: items.itemId,
                qty: items.qty,
                itemGrade: items.itemGrade,
                type: items.discountType || null,
                values: items.discountValue || 0
            }));
    
            setInputData((prevData) => ({
                ...prevData, ...updatedCartItems,
            }));
        }
    };

    useEffect(()=> {
        getTotal();
        setInuputs();
    },[orderData]);

    useEffect(()=> {
        getTotal();
    },[discounts]);


    const changeQty = (item, qty) => {
        setInputData((prevData) => {
            const updatedData = { ...prevData }; 
            
            for (let key in updatedData) {
                if (updatedData[key].product === item) {
                    updatedData[key].qty = qty;
                    break;
                }
            }
    
            return updatedData;
        });
    };
    

	const changeQtyBtn = (item, value) => {
        setInputData((prevData) => {
            const updatedData = { ...prevData };
    
            for (let key in updatedData) {
                if (updatedData[key].product === item) {
                    if (value === 'plus') {
                        updatedData[key].qty = parseFloat(updatedData[key].qty) + 0.5;
                    } else {
                        updatedData[key].qty = parseFloat(updatedData[key].qty) - 0.5
                    }
    
                    break;
                }
            }
    
            return updatedData;
        });
    };

    const handleDiscountTypeChange = (value, itemId) => {
        setNewDiscountData((prevData) => {
            const itemExists = prevData.some(item => item.item === itemId);

            if (itemExists) {
                // Update existing item
                return prevData.map(item =>
                    item.item === itemId ? { ...item, type: value } : item
                );
            } else {
                // Add new item
                return [...prevData, { type: value, discount: '', value: 0, item: itemId }];
            }
        });
    };

    const handleDiscountValueChange = (value, itemId) => {
        setNewDiscountData((prevData) => {
            const itemExists = prevData.some(item => item.item === itemId);

            if (itemExists) {
                // Update existing item
                //console.log('Exist', itemId);
                return prevData.map(item =>
                    item.item === itemId ? { ...item, value: value } : item
                );
            } else {
                // Add new item
                return [...prevData, { type: '', discount: '', value: value, item: itemId }];
            }
        });
    };

    const handleDiscountDiscountChange = (value, itemId) => {
        setNewDiscountData((prevData) => {
            const itemExists = prevData.some(item => item.item === itemId);

            if (itemExists) {
                // Update existing item
                return prevData.map(item =>
                    item.item === itemId ? { ...item, discount: value } : item
                );
            } else {
                // Add new item
                return [...prevData, { type: '', discount: value, value: 0, item: itemId }];
            }
        });
    };




    const getNewTotal = () => {
        // Initialize totals to zero
        let allTotal = 0;
        let allGst = 0;
        let allQty = 0;
        let allSubTotal = 0;
    
        orderData?.orderData?.forEach((data, index) => {
            const price = parseFloat(data.itemPrice) || 0;
            const gst = parseFloat(data.itemGst) || 0;

            const productGst = price - (price / (1 + gst / 100)) || 0;
            const productPrice = price - productGst || 0;
    
            allTotal += price * parseFloat(inputData[index]?.qty * parseFloat(inputData[index]?.itemGrade));
            allGst += productGst * parseFloat(inputData[index]?.qty) * parseFloat(inputData[index]?.itemGrade);
            allSubTotal += productPrice * parseFloat(inputData[index]?.qty) * parseFloat(inputData[index]?.itemGrade);
            allQty += parseFloat(inputData[index]?.qty) * parseFloat(inputData[index]?.itemGrade)|| 0;
            
        });
    
        // Set the final values
        setNewTotal(allTotal);
        setNewGst(allGst);
        setScheme(orderData?.schemeValue);
        getDiscount();
    };

    const getDiscounts = (product) => {
        
        const productData = orderData?.orderData?.find(items => items.itemId === product);
        const discountData = discounts?.find(items => items.item === product); 
    
        const qty = parseFloat(productData.qty);
        const price = parseFloat(productData.itemPrice);
        const crates = parseFloat(productData.itemGrade);
        const weight = parseFloat(productData.itemWeight);
        const gst = parseFloat(productData.itemGst);
        const productGst = price - (price / (1 + gst / 100)) || 0;
        const productPrice = price - productGst || 0;

        if (!productData || !discountData) {
            console.warn("Product or discount not found");
            return 0; 
        }

        if(discountData.type === 'grade'){

            if(discountData.crate === 'packet'){
                return (parseFloat(productPrice) * parseFloat(discountData.value)) * parseFloat(qty)
            }else{
                return parseFloat(discountData.value) * parseFloat(qty)
            }
        }

        if(discountData.type === 'percent'){
            const total = parseFloat(qty) * parseFloat(crates)* parseFloat(productPrice);
            return total*(parseFloat(discountData.value)/100)
        }

        if(discountData.type === 'liters'){

            if(discountData.crate === 'litre'){
                const litters = (parseFloat(qty) * parseFloat(crates)) * (parseFloat(weight)/1000)
                const weights = litters * discountData.value;
                const ltr = (weights * 1000) / weight;
                return ltr * productPrice
            }else{
                const litters = (parseFloat(qty) * parseFloat(crates)) * (parseFloat(weight)/1000)
                return litters * discountData.value
            }
        }

        return 0;
    };

    const getDiscount = () => {

        let discount = 0;

        orderData?.orderData?.forEach((data, index) => {
            if(inputData[index]?.type && inputData[index]?.type === 'grade'){
                const grade = parseFloat(inputData[index]?.qty);
                discount += parseFloat(inputData[index]?.values) * grade
            }
            if(inputData[index]?.type &&  inputData[index]?.type === 'percent'){
                const total = parseFloat(inputData[index]?.qty) * parseFloat(inputData[index]?.itemGrade) * parseFloat(data.itemPrice);
                discount += total*(parseFloat(inputData[index]?.values)/100)
            }
            if(inputData[index]?.type &&  inputData[index]?.type === 'liters'){
                const litters = parseFloat(inputData[index]?.qty) * parseFloat(inputData[index]?.itemGrade) * (parseFloat(data.itemWeight)/1000)
                discount += litters * inputData[index]?.values
            }
        });

        setNewDiscount(parseFloat(discount) + parseFloat(scheme));
    };

    useEffect(() => {
        getNewTotal();
        getDiscount();
    },[inputData, scheme, orderData]);

    
    const placeOrder = async () => {
        
        const sendData = {
            orderId: orderId,
            total: newTotal,
            gst: newGst,
            discount: newDiscount,
            items: inputData
        }
        try{
            const response = await axios.post('https://api.trucoo.in/chellan/edit/', sendData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });

            //console.log(response.data);

            if(response.data.status === 'success'){
                getOrder();
                setEdit(!edit);
            }

        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    // const downloadPDF = () => {
    //     const invoiceElement = document.getElementById("printableArea");
    //     invoiceElement.classList.remove("hide");

    //     html2canvas(invoiceElement, { scale: 2 }).then((canvas) => {
    //       const imgData = canvas.toDataURL("image/png");
    //       const pdf = new jsPDF("p", "mm", "a4");
    
    //       const pdfWidth = pdf.internal.pageSize.getWidth();
    //       const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    
    //       pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    //       pdf.save(`${orderData?.dealerData?.id}-${formatNumber(orderData?.id, 6)}-${orderData?.date}`);
    //       invoiceElement.classList.add("hide");
    //     });
    // };

    const downloadCombinedPDF = async () => {
        const sections = [
            document.getElementById("printableArea1"),
            (orderData?.eWayNum?.length > 8) ? document.getElementById("printableArea2") : null
            // document.getElementById("printableArea3"),
            // document.getElementById("printableArea4")
        ].filter(Boolean);;
         
           // Unhide all sections
        sections.forEach(el => el.classList.remove("hide"));
         
        const pdf = new jsPDF("p", "mm", "a4");
         
        for (let i = 0; i < sections.length; i++) {
            const element = sections[i];
            const canvas = await html2canvas(element, { scale: 2 });
            const imgData = canvas.toDataURL("image/jpeg");
         
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
         
            if (i > 0) pdf.addPage();
                pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
        }
         
        const filename = `${orderData?.dealerData?.id}-${formatNumber(orderData?.id, 6)}-${orderData?.date}`;
        pdf.save(filename);
         
        // Re-hide all sections
        sections.forEach(el => el.classList.add("hide"));
    };

    const manageInvoice = () => {
        setShowPopup(true);
    };

    const cancel = () => {
        setShowPopup(false);
    };

    const eWBcancel = () => {
		setEwbPop(false);
	};

    const formatDateEWB = (dateStr) => {
        console.log(dateStr);
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const getDistance = async () => {
        const origin = orderData?.dispatch?.pin;
        const destination = orderData?.shipping?.pin;

        if(!origin || origin?.length <= 0 || !destination || destination?.length <= 0){
            setDisterror('Invalid pincode! Please check pincode for Shipping address!');
            return;
        }
        const sendData = {
            origin: origin,
            destination: destination
        };

        try {
            const response = await axios.post('https://api.trucoo.in/distance/', sendData, {
                headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
            const element = response.data.data.rows[0].elements[0];
            if (element.status === 'OK') {
                const distanceText =  parseFloat(element.distance.text);
                setEWBInputs((prevData) => ({
                    ...prevData,
                    ['transDistance']: distanceText,
                }));
            } else {
                console.error('No route found between the locations.');
            }
        } catch (err) {
            console.error(err);
            console.error('Failed to fetch distance.');
        }
    };

    const extractDistance = (input) => {
        if (input.toLowerCase().includes('distance')) {
            const match = input.match(/\d+/);
            if (match) {
                return match[0]; // returns '141' as string
            }
        }
        return 0;
    };

    const fiscalYear = getFiscalYearLabel(new Date(orderData?.date));

    function getFiscalYearLabel(date = new Date()) {
        const year = date.getFullYear();
        const month = date.getMonth(); 
        if (month < 3) {
          return `${(year-1).toString().slice(-2)}-${year.toString().slice(-2)}`;
        } else {
          return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
        }
    };

    const formatViewInptDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            //console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getFullYear()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getDate()}`;
		return formattedDate;
	};

    const newData = (e) => {
        const { name, value } = e.target;
        setEWBInputs((prevData) => ({
          ...prevData,
          [name]: value,
        }));
    };

    useEffect(() => {
            setEWBInputs((prevData) => ({
              ...prevData,
              ['fromGstin']: '33AAKCT9681P1ZC',
              ['supplyType']: orderData?.ewb?.sType || '',
              ['subSupplyType']: orderData?.ewb?.ssType || '',
              ['docType']: orderData?.ewb?.docType || '',
              ['docNo']: orderData?.ewb?.docNo || `TRC/${orderData?.invoiceId}/${fiscalYear}`,
              ['docDate']: orderData?.ewb?.docDate || formatViewInptDate(orderData?.date),
              ['transDistance']: orderData?.ewb?.dist || '',
              ['transporterName']: orderData?.ewb?.tName || '',
              ['transporterId']: orderData?.ewb?.tId || '',
              ['transDocNo']: orderData?.ewb?.tdNo || '',
              ['vehicleNo']: orderData?.ewb?.vNum || orderData?.vNum || '',
              ['vehicleType']: orderData?.ewb?.vType || '',
              ['transMode']: orderData?.ewb?.tMode || '',
              ['orderId']: orderId,
            }));
    },[orderData]);

    const eWayBillData = async(e) => {
        console.log('Creating E Way Bill...');
        e.preventDefault();
        setLoader(true);

        if(!(orderData?.dealerData?.pincode) || (orderData?.dealerData?.pincode).length <= 0){
            setEWBError('Invalid Pincode for Party!');
            return;
        }

        const itemList = orderData?.orderData?.map(items => ({
            productName: items?.itemName,
            productDesc: items?.itemCode,
            hsnCode: items?.itemHsn,
            quantity: (parseFloat(items?.itemGrade) * parseFloat(items?.qty)),
            qtyUnit: "NOS",
            taxableAmount: Number(parseFloat((items?.itemGrade) * parseFloat(items?.qty) * parseFloat(items?.itemPrice)).toFixed(2)),
            sgstRate: Number(parseFloat((orderData?.dealerData?.gstType === 'SGST' ? parseFloat(items?.itemGst/2) : 0).toFixed(2))),
            cgstRate: Number(parseFloat((orderData?.dealerData?.gstType === 'SGST' ? parseFloat(items?.itemGst/2) : 0).toFixed(2))),
            igstRate: Number(parseFloat((orderData?.dealerData?.gstType === 'SGST' ? 0 :  parseFloat(items?.itemGst)).toFixed(2))),
            cessRate: 0,
        }));

        const eWayBillData = {
            supplyType: ewbInputs?.supplyType,
            subSupplyType: ewbInputs?.subSupplyType,
            subSupplyDesc: " ",
            docType: ewbInputs?.docType,
            docNo: ewbInputs?.docNo,
            docDate: formatDateEWB(ewbInputs?.docDate),
            fromGstin: '33AAKCT9681P1ZC',
            fromTrdName: 'TRUCOO DAIRY PRODUCTS PRIVATE LIMITED',
            fromAddr1: 'C201, SK Hill view Apartment',
            fromAddr2: 'Rainbow Enclave, Rainbow Colony,Myilkal, Sugunapuram, Coimbatore,C 201,Coimbatore,Tamil Nadu',
            fromPlace: 'Coimbatore',
            actFromStateCode: 33,
            fromPincode:  Number(orderData?.dispatch?.pin),
            fromStateCode:  33,
            ...(orderData?.dealerData?.gst?.length > 10 ? {
                toGstin: orderData?.dealerData?.gst,
            } : {toGstin: 'URP'}),
            toTrdName: orderData?.shipping?.company,
            toAddr1:orderData?.shipping?.address,
            toAddr2: orderData?.dealerData?.locations,
            toPlace: orderData?.dealerData?.locations,
            toPincode:  Number(orderData?.shipping?.pin),
            actToStateCode:  Number(orderData?.dealerData?.stateCode),
            toStateCode: Number( orderData?.dealerData?.stateCode),
            transactionType: 4,
            dispatchFromGSTIN: "33AAKCT9681P1ZC",
            dispatchFromTradeName: orderData?.dispatch?.company,
            ...(orderData?.shipping?.gstin?.length > 10 && {
                shipToGSTIN: orderData?.shipping?.gstin,
            }),
            shipToTradeName: orderData?.shipping?.company,
            totalValue: Number((parseFloat(orderData?.totalPayment) - parseFloat(orderData?.gst)).toFixed(2)),
            cgstValue: Number(orderData?.dealerData?.gstType === 'SGST' ? (parseFloat(orderData?.gst)/2).toFixed(2) : 0),
            sgstValue: Number(orderData?.dealerData?.gstType === 'SGST' ? (parseFloat(orderData?.gst)/2).toFixed(2) : 0),
            igstValue: Number(orderData?.dealerData?.gstType === 'SGST' ? 0 : parseFloat(orderData?.gst).toFixed(2)),
            // cessValue: 0,
            // cessNonAdvolValue: 0,
            totInvValue:  Number(parseFloat(orderData?.totalPayment).toFixed(2)),
            transMode: ewbInputs?.transMode,
            transDistance:  '0', // Math.ceil(ewbInputs?.transDistance)?.toString() ||
            ...(ewbInputs?.transporterName?.length > 0 && {
                transporterName: ewbInputs?.transporterName,
            }),
            ...(ewbInputs?.transporterId?.length > 0 && {
                transporterId: ewbInputs?.transporterId,
            }),
            ...(ewbInputs?.transDocNo?.length > 0 && {
                transDocNo: ewbInputs?.transDocNo,
            }),
            ...(ewbInputs?.transDocDate?.length > 0 && {
                transDocDate: ewbInputs?.transDocDate,
            }),
            vehicleNo: orderData?.vNum,
            vehicleType: ewbInputs?.vehicleType,
            itemList: itemList
        };

        console.log('EWay Bill',eWayBillData);

         try {
            const response = await axios.post('https://api.trucoo.in/ewaybill/', ewbInputs, {
                headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
            console.log(response.data);
        } catch (err) {
            console.error(err);
            console.error('Failed to fetch distance.');
        }

        console.log(eWayBillData);

        newEWayBill.createAuthToken().then(res => {
            console.log("Token Response:", res);

            if(res?.status_cd === '1'){
                newEWayBill.generateEwayBill(eWayBillData).then(res => {
                    console.log("E-Way Bill Response:", res);
                    updateEWayBill(res?.data);
                });
            }
        });
        setLoader(false);
       
    };

    const updateEWayBill = async(data) => {
            const distance = extractDistance(data?.alert|| '');
            const sendData = {
                data: data,
                ewayNum: data?.ewayBillNo || '',
                create: data?.ewayBillDate || '',
                valid: data?.validUpto || '',
                orderId: orderId,
                dist: distance
            };
    
            console.log(data);
    
            try{
                const response = await axios.post('https://api.trucoo.in/ewaybill/challan/', sendData, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-KEY': 'erpTrucoo'
                    }
                });
    
                console.log(response.data);
            } catch (err) {
                console.error(err);
                console.error('Failed to fetch distance.');
            }
            getOrder();
        };


    
return(
<>
{loader && <Loader /> }
    <div className="overlay" style={{ display: showPopup ? 'flex' : 'none', overflowY: 'scroll'}}>
        <div className="popup" style={{ position: 'relative', padding: '50px', width: '100%', maxWidth: '600px' }}>
            <button className="btn btn-danger" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={cancel} > <i className="fa fa-close"></i></button>
            <h4 className="text-bold mb-2">Manage Challan</h4>
            <div class="row mt-4 text-start">
                <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                <div class="form-group">
                    <label>Vehicle No</label>
                    <input type="text" class="form-control" placeholder='Enter vehicle Number' value={vNum} onChange={(e)=> setVNum(e.target.value)} />
                </div>
                </div>
                <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                <div class="form-group">
                    <label>E-Way Bill No</label>
                    <input type="text" class="form-control" placeholder='Eneter E-Way Bill Number' value={eNum} onChange={(e)=> setENum(e.target.value)} />
                </div>
                </div>
                <div class="col-12 col-md-12 col-xl-12 col-xxl-12 mt-2" style={{overflow: 'scroll'}}>
                <div class="form-group">
                    <label>Select Dispatch Address</label>
                    {address?.map(adrs => 
                    <div for={adrs.id} style={{padding: '10px', margin: '10px 0px', border: `${dispatchAddress === adrs.id ? '2px solid  #dbc359' : '1px solid  #333'}`, borderRadius: '10px'}}>
				        <input type="radio" id={adrs.id} name="modeOfPayment" value={adrs.id} checked={dispatchAddress === adrs.id ? true : false} onChange={(e)=> setDispatchAddress(e.target.value)} />
				        <label for={adrs.id} class="text-dark fs-11">{adrs.company} {adrs.address}</label>
                    </div>
                    )}
                </div>
                </div>

                 <div class="col-12 col-md-12 col-xl-12 col-xxl-12 mt-2">
                <div class="form-group">
                    <label>Select Shipping Address</label>
                    {shipping?.map(adrs => 
                    <div for={adrs.id} style={{padding: '10px', margin: '10px 0px', border: `${shippingAddress === adrs.id ? '2px solid  #dbc359' : '1px solid  #333'}`, borderRadius: '10px'}}>
				        <input type="radio" id={adrs.id} name="shippingAddress" value={adrs.id} checked={shippingAddress === adrs.id ? true : false} onChange={(e)=> setShippingAddress(e.target.value)} />
				        <label for={adrs.id} class="text-dark fs-11">{adrs.company} {adrs.address}</label>
                    </div>
                    )}
                </div>
                </div>
                
            </div>
            <button class="btn btn-success m-2" onClick={updateVENums}>Update</button>
            <button className="btn btn-danger m-2"onClick={cancel} > <i className="fa fa-close"></i></button>
        </div>
    </div>

    <div className="overlay" style={{ display: ewbPop ? 'flex' : 'none', overflowY: 'scroll'}}>
        <div className="popup" style={{ position: 'relative', padding: '50px', width: '100%', maxWidth: '80%', maxHeight: '90vh',overflowY: 'scroll'  }}>
            <button className="btn btn-danger" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={eWBcancel} > <i className="fa fa-close"></i></button>
            <h4 className="text-bold mb-2">Generate E-Way Bill</h4>
            <form onSubmit={eWayBillData}>
            <div class="row mt-4 text-start">
                <div class="col-lg-3 mt-2">
                    <p>Invoice From</p>
                    <p class="fs-10">
                        <b>TRUCOO DAIRY PRODUCTS PRIVATE LIMITED</b> <br />
                        C201, SK Hill view Apartment, 
                        Rainbow Enclave, Rainbow Colony, Myilkal, Sugunapuram, Coimbatore, Tamil Nadu<br />
                        GSTIN : 33AAKCT9681P1ZC
                    </p>
                </div>
                <div class="col-lg-3 mt-2">
                    <p>Invoice To</p>
                    <p class="fs-10">
                        <b>{orderData?.dealerData?.dealer} </b><br />
                        {orderData?.dealerData?.address}<br />
                        GSTIN : {orderData?.dealerData?.gst}<br />
                        PIN : {orderData?.dealerData?.pincode}
                    </p>
                </div>
                <div class="col-lg-3 mt-2">
                    <p>Dispatch From</p>
                    <p class="fs-10">
                        <b>{orderData?.dispatch?.company}</b><br />
                        {orderData?.dispatch?.address}<br />
                        PIN : {orderData?.dispatch?.pin}
                    </p>
                </div>
                <div class="col-lg-3 mt-2">
                    <p>Ships To</p>
                    <p class="fs-10">
                        <b>{orderData?.shipping?.company}</b><br />
                        {orderData?.shipping?.address}<br />
                        GSTIN : {orderData?.shipping?.gstin}<br />
                        PIN : {orderData?.shipping?.pin}
                    </p>
                </div>
                <hr class="m-2" />
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Supply Type</label>
                    <select class="form-select" name="supplyType" value={ewbInputs?.supplyType} onChange={(e)=>newData(e)} required >
                        <option value="">Select an Option</option>
                        <option value="O">Outward-Supply</option>
                        <option value="I">Inward-Supply</option>
                    </select>
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Sub-Supply Type</label>
                    <select class="form-select" name="subSupplyType" value={ewbInputs?.subSupplyType} onChange={(e)=>newData(e)} required >
                        <option value="">Select an Option</option>
                        <option value="1">Supply</option>
                        <option value="2">Import</option>
                        <option value="3">Export</option>
                        <option value="4">Job Work</option>
                        <option value="5">For Own Use</option>
                        <option value="6">Job Work Returns</option>
                        <option value="7">Sales Return</option>
                        <option value="8">Others</option>
                        <option value="9">SKD/CKD/Lots</option>
                        <option value="10">Line Sales</option>
                        <option value="11">Recipient Not Known</option>
                        <option value="12">Exhibition or Fairs</option>
                    </select>
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Document Type</label>
                    <select class="form-select" name="docType" value={ewbInputs?.docType} onChange={(e)=>newData(e)} required >
                        <option value="">Select an Option</option>
                        <option value="INV">Invoice</option>
                        <option value="CHL">Delivery Challan</option>
                        <option value="BIL">Bill of Supply</option>
                        <option value="BOE">Bill of Entry</option>
                        <option value="OTH ">Others</option>
                    </select>
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Document No</label>
                    <input type="text" class="form-control" name="docNo" value={ewbInputs?.docNo} onChange={(e)=>newData(e)} required />
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Document Date</label>
                    <input type="date" class="form-control" name="docDate" value={ewbInputs?.docDate} onChange={(e)=>newData(e)} required />
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Distance</label>
                    <div class="input-group">
                        <input type="text" class="form-control" name="transDistance" value={ewbInputs?.transDistance} onChange={(e)=>newData(e)} required />
                        <button type="button" class="btn btn-sm btn-success" onClick={getDistance}>Get Distance</button>
                    </div>
                    {distError && distError?.length > 0 && <p class="fs-10 text-danger">{distError}</p> }
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Transporter Name</label>
                    <input type="text" class="form-control" name="transporterName" value={ewbInputs?.transporterName} onChange={(e)=>newData(e)} />
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Transporter ID</label>
                    <input type="text" class="form-control" name="transporterId" value={ewbInputs?.transporterId} onChange={(e)=>newData(e)}  />
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Transporter Doc No</label>
                    <input type="text" class="form-control" name="transDocNo" value={ewbInputs?.transDocNo} onChange={(e)=>newData(e)}  />
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Vehicle Number</label>
                    <input type="text" class="form-control" name="vehicleNo" value={ewbInputs?.vehicleNo} onChange={(e)=>newData(e)} required />
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Vehicle Type</label>
                    <select class="form-select" name="vehicleType" value={ewbInputs?.vehicleType} onChange={(e)=>newData(e)} required >
                        <option value="">Select an Option</option>
                        <option value="R">Regular</option>
                        <option value="O">ODC(Over Dimentional Cargo)</option>
                    </select>
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Trsnsport Mode</label>
                    <select class="form-select" name="transMode" value={ewbInputs?.transMode} onChange={(e)=>newData(e)} required >
                        <option value="">Select an Option</option>
                        <option value="1">Road</option>
                        <option value="2">Rail</option>
                        <option value="3">Air</option>
                        <option value="4">Ship</option>
                    </select>
                </div>
                {orderData?.eWayNum === '' || orderData?.eWayNum === null || !orderData?.eWayNum || orderData?.eWayNum?.length <= 8 ?
                    <div class="col-lg-12 mt-2" align="center">
                        <button type="submit" class="btn btn-success mt-4">Create E-Way Bill</button>
                        {ewbError && ewbError.length > 0 && <p class="fs-12 text-danger text-center mt-2">{ewbError}</p> }
                    </div>
                    : <h5 class="mt-4 text-center">E-Way Bill No : {orderData?.eWayNum}</h5>
                }
            </div>
            </form>
        </div>
    </div>

    <Header />
    <Sidebar />

    <div class="content-wrapper">
        <div class="container-full">
        
            <section class="content">

            <div class="box">
                <div class="box-header with-border">
                  <h4 class="box-title">Challan Details</h4>
                  <p class="mb-0 box-subtitle">Ref ID : {orderId}</p>
                  <p class="mb-0 box-title">Date : {orderData?.date}</p>
                </div>
                <div class="box-body">
                    <div class="row">
                        <div class="col-lg-12 mt-4" style={{border: '1px solid #333', borderRadius: '10px', padding: '20px 25px'}}>
                            <div class="row">
                                <div class="col-lg-5 mt-2">
                                
                                        <h6>Invoice To</h6>
                                        <small> <b>{orderData?.dealerData?.dealer}</b><br />
                                            {orderData?.dealerData?.name} {orderData?.dealerData?.address}<br />
                                            {orderData?.dealerData?.gst}, {orderData?.dealerData?.phone}, {orderData?.dealerData?.email}
                                        </small> 

                                        <h6 class="mt-4">Ships To</h6>
                                        <small> <b>{orderData?.shipping?.company}</b><br />
                                            {orderData?.shipping?.address}<br />
                                            {orderData?.shipping?.phone}, {orderData?.shipping?.email}
                                        </small> 

                                        <h6 class="mt-4">Dispatch From</h6>
                                        <small> <b>{orderData?.dispatch?.company}</b><br />
                                            {orderData?.dispatch?.address}<br />
                                            {orderData?.dispatch?.phone}, {orderData?.dispatch?.email}
                                        </small> 
                                 
                                </div>

                                <div class="col-lg-3 mt-2">
                                    <table width="100%">
                                        <tr>
                                            <td style={{padding: '5px'}}>Sub Total</td>
                                            <td style={{padding: '5px'}}>₹ {(parseFloat(orderData?.totalPayment) - parseFloat(orderData?.gst)).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>GST</td>
                                            <td style={{padding: '5px'}}>₹ {parseFloat(orderData?.gst).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>Discount</td>
                                            <td style={{padding: '5px'}}>₹ {parseFloat(orderData?.discount + orderData?.schemeValue).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <th style={{padding: '5px'}}>Grand Total</th>
                                            <th style={{padding: '5px'}}>₹ {(parseFloat(orderData?.totalPayment) - parseFloat(orderData?.discount) - parseFloat(orderData?.schemeValue)).toFixed(2)}</th>
                                        </tr>
                                        {/* <tr>
                                            <th style={{padding: '5px'}}>Payment</th>
                                            <th style={{padding: '5px'}}>{orderData?.paymentStatus}</th>
                                        </tr> */}
                                        <tr>
                                            <td style={{padding: '5px'}}>Vehicle No</td>
                                            <td style={{padding: '5px'}}>{vNum}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>E-Way Bill</td>
                                            <td style={{padding: '5px'}}>{eNum}</td>
                                        </tr>
                                    </table>
                                </div>


                                <div class="col-lg-4 mt-2" align="center" >
                                    <table width="100%" class="text-center">
                                        
                                    </table>
                                    {/* <button class="btn btn-primary mt-2" onClick={()=> {setEdit(!edit)}}><i class="fa fa-edit"></i></button> <br /> */}
                                    {/* <button class="btn btn-danger mt-2"><i class="fa fa-trash"></i></button> <br /> */}
                                    {/* <button class={`btn ${orderData?.paymentStatus === 'paid' ? 'btn-success' : 'btn-warning'} mt-2`} onClick={changeStatus}><i class="fa fa-inr"></i> {orderData?.paymentStatus}</button> <br /> */}
                                    <button class="btn btn-success mt-4" onClick={manageInvoice}>Manage Challan</button> <br />
                                    <button class="btn btn-success mt-2" onClick={()=>setEwbPop(true)}>E Way Bill</button>
                                </div>

                            </div>
                        </div>

                        {!edit ?


                        <div class="col-lg-12 mt-2">
                            <div class="box-header with-border">
                                <p class="mb-0 box-subtitle">Order Items</p>
                            </div>
                            <div class="box-body">
                                <div class="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr className="fs-10 fw-600 text-dark">
                                            <th rowspan="2" width="3%">S.No</th>
                                            <th rowspan="2">PARTICULARS</th>
                                            <th rowspan="2" width="4%">UNIT</th>
                                            <th rowspan="2" width="8%">CRATES</th>
                                            <th rowspan="2" width="8%">QTY</th>
                                            <th rowspan="2" width="8%">LTR</th>
                                            <th rowspan="2" width="6%">RATE</th>
                                            <th rowspan="2" width="8%">AMOUNT</th>
                                            {orderData?.dealerData?.gstType === 'SGST' ? 
                                                <>
                                                    <th colspan="2" width="8%">CGST</th>   
                                                    <th colspan="2" width="8%">SGST</th>
                                                </>
                                            :
                                                <th colspan="2" width="8%">IGST</th>  
                                            }
                                            <th rowspan="2" width="8%">Doscount</th>
                                            <th rowspan="2" width="10%">Total Amount</th>
                                        </tr>
                                        <tr className="fs-10 fw-800 text-dark">
                                            {orderData?.dealerData?.gstType === 'SGST' && 
                                            <>
                                                <th>Rate(%) </th>
                                                <th>Value </th>
                                            </>
                                            }
                                          <th>Rate(%) </th>
                                          <th>Value </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderData && orderData?.orderData?.map((data, index) => {
                                          
                                            const price = parseFloat(data.itemPrice);
                                            const gst = parseFloat(data.itemGst);
                                            const productGst = parseFloat(price - ( price / (1+ gst/100) ));
                                            const productPrice = parseFloat(price - productGst);
                                            const disCrates = getDiscountCrates(data.itemId);
                                            const discount = getDiscounts(data.itemId);
                                            //console.log(discount); 
                                            

                                            return(
                                            <tr key={index} className="fw-400 text-gray-600  fs-12">
                                                <td>{index + 1}</td> 
                                                <td class="text-left">{data.itemName}</td>
                                                <td>{data.itemUnit}</td>
                                                <td>{(parseFloat(data.qty) + parseFloat(disCrates)).toFixed(2)}</td>
                                                <td>{((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                <td>{((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade) * parseFloat(data.itemWeight)/1000).toFixed(2)}</td>
                                                <td>{parseFloat(productPrice).toFixed(2)}</td>
                                                <td>{parseFloat(productPrice.toFixed(2)* ((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade))).toFixed(2)}</td>
                                                {orderData?.dealerData?.gstType === 'SGST' ?
                                                    <>
                                                        <td>{parseFloat(data.itemGst/2).toFixed(1)}%</td>
                                                        <td>{parseFloat((productGst/2) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                        <td>{parseFloat(data.itemGst/2).toFixed(1)}%</td>
                                                        <td>{parseFloat((productGst/2) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                    </>
                                                :
                                                    <>
                                                        <td>{parseFloat(data.itemGst).toFixed(1)}%</td>
                                                        <td>{parseFloat((productGst) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                    </>
                                                }
                                                <td>{parseFloat(discount).toFixed(2)}</td>
                                                <td class="text-end">{((parseFloat(data.itemPrice) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)) - parseFloat(discount) ).toFixed(2)}</td>

                                                                                                
                                            </tr>);
                                           })}
                                       
                                        <tr>
                                            
                                            <th colspan="3">TOTAL</th>
                                           
                                            <th>{parseFloat(crates).toFixed(2)}</th>
                                            <th>{parseFloat(qty).toFixed(2)}</th>
                                            <th>{parseFloat(weight).toFixed(2)}</th>
                                            <th></th>
                                            <th>{parseFloat(total).toFixed(2)}</th>
                                            {orderData?.dealerData?.gstType === 'SGST' ?
                                                <>
                                                    <th></th>
                                                    <th>{parseFloat(gst/2).toFixed(2)}</th>
                                                    <td></td>
                                                    <th>{parseFloat(gst/2).toFixed(2)}</th>
                                                </>
                                                :
                                                <>
                                                    <td></td>
                                                    <th>{parseFloat(gst).toFixed(2)}</th>
                                                </>
                                            }
                                            <th class="text-end">{parseFloat(orderData?.discount).toFixed(2)}</th>
                                            <th class="text-end">{parseFloat(grandTotal - orderData?.discount).toFixed(2)}</th>

   
                                        </tr>
                            
                                        </tbody>	
                                    </table>
                                </div>              
                            </div>  
                        </div>
                        :
                        <div class="col-lg-12 mt-2" ref={bottomRef}>
                            <div class="box-header with-border">
				                <p class="mb-0 box-subtitle">Edit Order Items</p>
				            </div>
				            <div class="box-body" align="right">
					            <div class="table-responsive">
                                <table className="table-sm table-bordered" width="100%">
                                    <thead>
                                        <tr className="fs-10 fw-600 text-dark">
                                            <th width="4%">S.No</th>
                                            <th>PARTICULARS</th>
                                            <th width="15%">CRATES</th>
                                            <th width="30%">DISCOUNT</th>
                                            <th width="8%">AMOUNT</th>
                                            <th width="5%">DISCOUNT</th>
                                            <th width="8%">TOTAL</th>
                                            <th width="8%">REMOVE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderData?.orderData?.map((data, index) => {

                                            const discount = getNewDiscounts(data.itemId);
                                            const disCrates = getDiscountCrates(data.itemId);
                                            const qty = parseFloat(parseFloat(Object.values(inputData).find(item => item.product === data.itemId)?.qty) + parseFloat(disCrates)).toFixed(2);
                                            const price = parseFloat(data.itemPrice);
                                            const gst = parseFloat(data.itemGst);
                                            const productGst = parseFloat(price - ( price / (1+ gst/100) ));
                                            const productPrice = parseFloat(price - productGst);

                                            const rate = parseFloat(productPrice.toFixed(2)* ((parseFloat(qty)+ parseFloat(disCrates))* parseFloat(data.itemGrade))).toFixed(2);
                                            const gstRate = rate * (parseFloat(data.itemGst)/100);

                                            const Total = parseFloat(parseFloat(rate) + parseFloat(gstRate));

                                            return(
                                            <tr key={index} className="fw-400 text-gray-600  fs-12">
                                                <td>{index + 1}</td> 
                                                <td class="text-left">{data.itemName}</td>
                                                <td>
                                                    <div class="input-group">
													    <button type="button" class="btn btn-info btn-sm" style={{padding: '5px 15px'}} onClick={()=> {changeQtyBtn(data.itemId, 'minus')}}>-</button>
									            	    <input type="number" class="form-control" style={{textAlign: 'center'}} value={Object.values(inputData).find(item => item.product === data.itemId)?.qty || ''} onChange={(e)=> changeQty(data.itemId, e.target.value)} />
									        		    <button type="button" class="btn btn-info btn-sm" style={{padding: '5px 15px'}} onClick={()=> {changeQtyBtn(data.itemId, 'plus')}}>+</button>
												    </div>
                                                </td>
                                                <td>
                                                    <div class="input-group">
                                                        <select className="form-select" name="type" value={newDiscountData.find(entry => entry.item === data.itemId)?.type || ''} onChange={(e)=> handleDiscountTypeChange(e.target.value, data.itemId)}>
                                                            <option value="" hidden>Select Options</option>
                                                            <option value="liters">Littres</option>
                                                            <option value="grade">Crates</option>
                                                            <option value="packet">Packets</option>
                                                        </select>
                                                        <select className="form-select" name="discount" value={newDiscountData.find(entry => entry.item === data.itemId)?.discount || ''} onChange={(e)=> handleDiscountDiscountChange(e.target.value, data.itemId)}>
                                                            <option value="" hidden>Select Options</option>
                                                            <option value="amount">Amount</option>
                                                            <option value="packet">Packet</option>
                                                        </select>
                                                        <input type="parseFloat" class="form-control" style={{textAlign: 'center'}} name="value" value={newDiscountData.find(entry => entry.item === data.itemId)?.value || ''} onChange={(e)=> handleDiscountValueChange(e.target.value, data.itemId)} />
                                                    </div>
                                                </td>
                                                <td>{parseFloat(Total).toFixed(2)}</td>
                                                <td>{parseFloat(discount).toFixed(2)}</td>
                                                <td>{(parseFloat(Total) - parseFloat(discount)).toFixed(2)}</td>
                                                {/* <td><button class="btn btn-danger" onClick={()=> {removeItem(data.id)}}><i class="fa fa-trash"></i></button></td> */}
                                            </tr>
                                        )})}
                                            <tr>
                                                <th colspan="4">Total</th>
                                                <th>{parseFloat(newTotal + newGst).toFixed(2)}</th>
                                                <th>{parseFloat(newDiscount).toFixed(2)}</th>
                                                <th>{(parseFloat(newTotal + newGst) - parseFloat(newDiscount)).toFixed(2)}</th>
                                            </tr>
                                    </tbody>
                                </table>

                                <button class="btn - btn-danger me-2 mt-4" onClick={()=> {setEdit(!edit)}}>Cancel</button>
                                {/* <button class="btn - btn-success me-2 mt-4" onClick={()=> {setAddSection(!addSection)}}>Add Items</button> */}
                                <button class="btn - btn-primary mt-4" onClick={placeOrder}>Update Invoive</button>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                    
                    <div class="row">
                        <div class="col-lg-12 mt-4" align="right">
                            <Challan 
                                getData={orderData} 
                            />
                            <button class="btn btn-success" onClick={downloadCombinedPDF}>Download Challan</button>
                        </div>
                    </div>
                </div>
              </div>
            </section>
        </div>
    </div>

    <Footer />
</>
);
}

export default App;